class Header{
    constructor(){
        this.header = document.querySelector('.header');
        this.hamb = document.querySelector('.header__hamburger');

        !this.hamb || this.hamb.addEventListener('click', e => {
            e.preventDefault();
            this.header.classList.toggle('active');
        })
        if(window.innerWidth < 991) this.mobileShow();
    }

    mobileShow(){
        this.header.querySelectorAll('.item--lists, .item--box').forEach(el => {
            el.querySelector('button').addEventListener('click', e => {
                e.preventDefault();
                el.classList.toggle('active');
            })
        })
    }
}
export default Header;